import { Component, Input, OnInit } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { CustomerService } from "src/app/core/services/customer.service";
import { CustomerVenueVisit } from "src/app/shared/models/Customer/CustomerVenueVisit.entity";

@Component({
	selector: "app-about-me-venue-visit-list",
	templateUrl: "./about-me-venue-visit-list.component.html",
	styleUrls: ["../../../../../customer.scss"],
})
export class AboutMeVenueVisitListComponent implements OnInit {
	@Input() venueKey: number;

	venueVisits: CustomerVenueVisit[];
	constructor(public app: AppService, public customerService: CustomerService) {}

	ngOnInit(): void {
		this.venueVisits = this.customerService.publicCustomer.value.venues.find((venue) => venue.venueKey === this.venueKey).visits;
		this.venueVisits.forEach((visit) => {
			visit.sourceObject = this.app.references.checkSourceObjectFromCheckEnum(visit.source);
		});
		this.venueVisits.sort((a, b) => (this.app.moment(a.visitDateTime).unix() < this.app.moment(b.visitDateTime).unix() ? 1 : -1));
	}

	onVisitSelect(rec: CustomerVenueVisit) {
		const link = document.createElement("a");
		link.href = rec.checkDto.receiptUrl;
		link.target = "_blank";
		link.click();
	}
}
